import { InjectionToken } from '@angular/core';

/**
 * Shared SSR tokens for server-side rendering context.
 * Use these tokens to inject the request and response objects in Angular Universal/Nx SSR setups.
 */
export const REQUEST = new InjectionToken<IRequest>('REQUEST');
export const RESPONSE = new InjectionToken<unknown>('RESPONSE');
export const SSR_REQUEST = new InjectionToken<Request>('SSR_REQUEST');
export const SSR_RESPONSE = new InjectionToken<Response>('SSR_RESPONSE');

/**
 * AbortSignal for SSR renders. When a render times out, this signal is aborted
 * to allow in-flight HTTP requests to be cancelled and cleanup to proceed.
 */
export const SSR_ABORT_SIGNAL = new InjectionToken<AbortSignal>('SSR_ABORT_SIGNAL');

/**
 * Amplitude Experiment RemoteEvaluationClient class (or factory) for SSR.
 * Provided only in the server bundle so the shared amplitude lib never imports Node-only packages.
 */
export const AMPLITUDE_EXPERIMENT_CLIENT = new InjectionToken<unknown>('AMPLITUDE_EXPERIMENT_CLIENT');

export interface IRequest {
  headers: {
    cookie?: string;
    'user-agent'?: string;
    [key: string]: string | string[] | undefined;
  };
}
